import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  saveButton: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
});

export default useStyles;
